import { FunctionFactory } from 'survey-core';
import { locHtml } from './locHtml';
import { makeSplashHeader } from './SplashHeader';

const consistencySplashHtml = locHtml((t) => `
<div class="new-quote-container centered"> 
  <div class="splash-icon">🧩</div>
  <div class="splash-header">
    <h1>${t("splash.consistency.title")}</h1>
    <div class="quote">
      ${t("splash.consistency.text")}
    </div>
  </div>
</div>`);

const consistencySplashExpression = {
  name: "consistencyQuote",
  expression: "renderConsistencyQuote({consistency})",
};

function renderConsistencyQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  return "That's very common. Habit building is the key to overcoming this. Most programs don't teach this. We make this easy for you";
}

FunctionFactory.Instance.register("renderConsistencyQuote", renderConsistencyQuote);

const consistencySplashElement = {
  visibleIf: `{consistency} > 3`,
  name: 'consistency-splash',
  type: 'html',
  html: consistencySplashHtml,
}

const ConsistencySplashHeader = makeSplashHeader("splash.headers.consistency");


export {
  consistencySplashElement,
  consistencySplashExpression,
  ConsistencySplashHeader,
}